import React from 'react'
import styles from './Deposit.module.scss'
import { FormDeposit } from 'components/FormDeposit/FormDeposit'
import { MOCK_USER_DATA } from 'components/FormDeposit/const'
import { useAppSelector } from 'redux/hooks'
import { THEME_COLORS } from 'components/PopupEditPage/EditPage/FormEdit/consts'


export function Deposit() {
    const { theme } = useAppSelector((state) => state.root)
    const [data, setData] = React.useState(MOCK_USER_DATA)

    return (
        <div
            className={styles['wrapperMain']}
            style={{ backgroundColor: THEME_COLORS[theme] }}
        >
            <FormDeposit data={data} />
        </div>
    );
}

